import GoogleReviewSummary from "@/components/Landingpage/GoogleStars";
import { cn } from "@/lib/utils";
import React from "react";

export default function Proof({ text, className }) {
  return (
    <div>
      <div className={cn("flex items-center  justify-evenly", className)}>
        <GoogleReviewSummary  text={text}  />
          <img
            className="ml-5 w-24 h-24 md:h-20 md:w-20"
            src="/Logos/IVD-Logo.png"
            alt="Logo vom Immobilienverband Deutschland e.V. (IVD)"
          />
          <img
            className="pl-3 h-28 object-contain md:h-24 md:w-24"
            src="/Fotos/Partner-Siegel-Immoscout24.png"
            alt="Logo vom Siegel von Immoscout24"
          />
      </div>
    </div>
  );
}
